import { useMemo } from 'react';
import getStepType from '../../Workflow/stepTypes';
import DefaultNode from './DefaultNode';
import DecisionNode from './DecisionNode';
import WorkflowStepHandles from './handles/WorkflowStepHandles';

export default function WorkflowStepNode(props) {
  const {
    positionAbsoluteX: x,
    positionAbsoluteY: y,
    width,
    height,
    selected,
    data: { stepdef },
  } = props;

  const { shape, Icon: icon } = useMemo(() => getStepType(stepdef?.type), [stepdef?.type]);

  if (shape === 'diamond') {
    return <DecisionNode {...props} />;
  }

  return <DefaultNode {...props} shape={shape} icon={icon} handles={<WorkflowStepHandles {...props} />} />;
}
